<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import Modal from '../$components/modal.container.svelte'

    import OrdenesComponent from './component.ordenes.svelte'
    import OrdenComponent from './component.orden.svelte'
    import SaldoComponent from './component.saldo.svelte'

    if(!isPermission($adminStore, 'StpView'))
        replace('/404')

</script>

<View>
    <PageHeader title="STP" subtitle="Órdenes de pago SPEI" />
    <SaldoComponent />
    <OrdenesComponent />
</View>

<Modal id="stpOrden_modal" title="Orden STP">
    <OrdenComponent />
</Modal>
